"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Card = _interopRequireDefault(require("../Card"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _Skeleton = _interopRequireDefault(require("../Skeleton"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreemptionCardLoading = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.default, {
    shadow: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.WrapperHeader, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {
        rectangle: true
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.WrapperUnitInformation, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {})]
    })]
  });
};
var _default = exports.default = PreemptionCardLoading;